import React from "react";
import { NotFoundSearchIcon } from "../../utils/svg";

const SearchNotFound = () => {
  return (
    <div className="px-4 flex flex-col justify-center items-center">
      <NotFoundSearchIcon className="w-56 h-auto fill-[var(--rose-violet)]" />
      <p className="font-semibold text-lg text-[var(--dark-gray)] mb-1">
        Hmm, no restaurant found
      </p>
      <p className="text-sm text-[var(--dark-gray)] text-center px-14">
        We couldn't locate what you're looking for. How about trying something
        else?
      </p>
    </div>
  );
};

export default SearchNotFound;
